<template>
	<div class="position-relative">
		<a 
			class="copy-link-button"
			:style="copyLinkButtonSize"
			@click="copyLink()"
		>
			<img
				src="../../../assets/images/img_copy_button.png"
				class="w-100"
			/>
		</a>
		<transition name="fade">
			<div
				v-if="showMessage"
				class="copy-link-message"
				:style="messagePosition"
			>
				リンクをコピーしました
			</div>
		</transition>
	</div>
</template>


<script>
import "../i18n/ja";
import { i18n } from "../mixins/i18n";

export default {
  mixins: [i18n],
	data() {
		return {
			showMessage: false
		}
	},
  props: {
    pagePath: {
      type: String,
      required: true
    },
		buttonSize: {
			type: String,
			default: "42"
		}
  },
	computed: {
    copyLinkButtonSize () {
      return {
        '--button-size': `${this.buttonSize}px`
      }
    },
		messagePosition () {
			return {
				'--message-postion': `-${(152 - this.buttonSize) / 2 }px`,
			}
		}
  },
  methods: {
    copyLink() {
      navigator.clipboard.writeText(this.pagePath);
			this.showMessage = true

      setTimeout(() => {
				this.showMessage = false
      }
      , 2000);
    }
  }
};
</script>

<style lang="scss" scoped>
.copy-link-button {
	width: var(--button-size);
	height: var(--button-size);
	display: block;
	&:hover {
		transform: rotate(23deg);
		* {
			opacity: 1;
		}
	}
}

.copy-link-message {
	position: absolute;
	top: -40px;
	left: var(--message-postion);
	width: max-content;
	border-radius: 3px;
	font-size: 12px;
	color: #fff;
	padding: 3px 10px;
	display: inline-block;
	background-color: #18bd86;
	&:before {
    position: absolute;
    content: '';
    width: 0;
    height: 0;
    top: 25px;
    left: 66px;
    border-style: solid;
    border-width: 11px 10px 0px;
    border-color: #18bd86 transparent transparent transparent;
	}
}

// vueの<transition>機能で使用しているクラス
.fade-enter-active,
.fade-leave-active {
	transition: opacity .1s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

</style>
